import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { FaChevronDown } from 'react-icons/fa';
// import axios from "axios";
import "../styles/AppDev.css";
// import img1 from "../image/i1.webp";
// import img2 from "../image/i2.webp";
// import img3 from "../image/i3.webp";
// import img4 from "../image/i4.webp";
// import img5 from "../image/i5.webp";
// import img6 from "../image/i6.webp";
// import img7 from "../image/i7.webp";
// import img8 from "../image/i8.webp";
// import hr from "../image/hrmanage.webp";
// import nutrition from "../image/nutrition.webp";
// import talent from "../image/talent.webp";
// import astrology from "../image/astrology.webp";
import ContactPage from "./ContactPage";
// import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { motion } from "framer-motion";

const AppDev = () => {
  // const [firstName, setFirstName] = useState("");
  // const [lastName, setLastName] = useState("");
  // const [gmail, setGmail] = useState("");
  // const [message, setMessage] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [visibleRows, setVisibleRows] = useState({});
  // const [phone, setPhone] = useState("");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // const handleImageClick = (index) => {
  //   if (isMobile) {
  //     setActiveIndex(activeIndex === index ? null : index);
  //   }
  // };

  const handleToggle = (id) => {
    setVisibleRows((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const data = [
    {
      id: 1,
      title: "Do I need to develop an app for both iOS and Android?",
      content:
        "It's not mandatory to develop for both platforms, but doing so allows you to reach a larger audience. You can choose based on your target audience or budget constraints."
    },
    {
      id: 2,
      title: "What technologies are used in mobile app development?",
      content:
        "Common technologies like React Native, Flutter and PHP for building apps that work on multiple platforms."
    },
    {
      id: 3,
      title: "How do you ensure the security of a mobile app?",
      content:
        "We use encryption, secure APIs, authentication protocols (like OAuth), and other security best practices to ensure your mobile app and its data are protected from potential threats."
    },
    {
      id: 4,
      title: "What is front-end development ?",
      content:
        "Front-end development in mobile app development focuses on designing and building the user interface and experience for mobile applications."
    },
    {
      id: 5,
      title: "What is Back-end development ?",
      content:
        "Back-end development in mobile app development involves creating the server-side logic, databases, and APIs that support app functionality and data management."
    }
  ];

  // const handleNext = () => {
  //   setActiveIndex((prev) => (prev + 1) % steps.length);
  // };

  // const handlePrev = () => {
  //   setActiveIndex((prev) => (prev - 1 + steps.length) % steps.length);
  // };

  // const services = [
  //   {
  //     title: "Android App Development",
  //     description:
  //       "Our Android app development services focus on creating high-performance, user-friendly applications appropriate to your business needs. We leverage the latest Android SDKs and technologies to build scalable, robust, and secure apps. Our team ensures seamless integration, thorough testing, and timely delivery, driving your business's mobile presence."
  //   },
  //   {
  //     title: "iOS App Development",
  //     description:
  //       "Our iOS app development services deliver high-quality, user-friendly applications for iPhones We ensure seamless performance and integration with the Apple ecosystem. Our expertise spans UI/UX design, development, testing and deployment, creating engaging and reliable iOS experiences."
  //   },
  //   {
  //     title: "Flutter App Development",
  //     description:
  //       "Our Flutter app development services deliver cross-platform applications with native-like performance. We leverage Flutter's single codebase to create visually appealing and highly functional apps for iOS and Android. Our expertise encompasses UI/UX design, seamless API integrations, and efficient state management. We ensure rapid development, cost-effectiveness, and consistent user experiences across platforms."
  //   },
  //   {
  //     title: "React Native Development",
  //     description:
  //       "Our React Native Development Services offer high performance, cross platform mobile apps for both iOS and Android. Leveraging React Native’s efficiency, we build fast, scalable, and cost-effective solutions with a native-like experience. Our expert team ensures seamless integration, intuitive UI/UX design, and reliable functionality across devices."
  //   },
  //   {
  //     title: "Hybrid App Development",
  //     description:
  //       "Our Hybrid App Development Services deliver cost-effective and high-performance apps for both iOS and Android platforms. Using frameworks like React Native and Flutter, we create cross-platform solutions with native-like functionality. Our expert team ensures a seamless user experience, fast performance, and smooth integration across devices."
  //   },
  //   {
  //     title: "Cross-platform App Development",
  //     description:
  //       "Our Cross-Platform App Development Services enable businesses to create mobile apps that work seamlessly across iOS and Android with a single codebase. Using technologies like React Native, Flutter, and Xamarin, we deliver high-performance apps that provide a native-like experience. Our team focuses on intuitive design, fast performance."
  //   }
  // ];

  // const features = [
  //   {
  //     img: "/images/image 26.webp",
  //     bgImg: "/images/bg1.webp",
  //     title: "Customized App Development",
  //     description:
  //       "Mobile App created according to needs perfectly aligned with your business's unique requirements. We craft applications that address specific challenges, enhance workflows and engage your target audience, ensuring optimal performance and a customized user experience."
  //   },
  //   {
  //     img: "/images/image 27.webp",
  //     bgImg: "/images/bg2.webp",
  //     title: "Platform Compatibility",
  //     description:
  //       "It ensures your app functions seamlessly across diverse operating systems (iOS, Android). We prioritize cross-platform development, accurate testing, and adaptation to device variations, delivering a consistent and optimal user experience."
  //   },
  //   {
  //     img: "/images/image 28.webp",
  //     bgImg: "/images/bg3.webp",
  //     title: "Intuitive User Interface",
  //     description:
  //       "Intuitive user interface design prioritizes simplicity and ease of use. We create seamless navigation, clear visual and responsive interactions, ensuring users effortlessly achieve their goals, resulting in a delightful and engaging app experience."
  //   },
  //   {
  //     img: "/images/image 29.webp",
  //     bgImg: "/images/bg4.webp",
  //     title: "Scalability and Performance",
  //     description:
  //       "Scalability and performance are vital for app success. We build apps to handle growth, ensuring speed and stability. Optimized code, efficient architecture, and rigorous testing guarantee a smooth user experience."
  //   },
  //   {
  //     img: "/images/image 30.webp",
  //     bgImg: "/images/bg5.webp",
  //     title: "Third-Party Integrations",
  //     description:
  //       "Extend app functionality by connecting with external services. We seamlessly incorporate APIs for payments, social media, and analytics, enhancing user experience and providing valuable features within your application."
  //   },
  //   {
  //     img: "/images/image 31.webp",
  //     bgImg: "/images/bg6.webp",
  //     title: "Offline Capabilities",
  //     description:
  //       "Ensure your app remains functional without internet access. We implement local data storage and synchronization, allowing users to access core features and content even when connectivity is limited."
  //   }
  // ];

  // const steps = [
  //   {
  //     title: "Idea & Conceptualization",
  //     content:
  //       "The foundation of any successful mobile app starts with a clear idea. We begin by deeply understanding your core vision and business objectives, conducting thorough market research to identify opportunities and potential challenges. We then define your target audience and their specific needs, translating these insights into detailed user personas and user journeys. Through collaborative brainstorming sessions and iterative prototyping, we refine your app's concept, focusing on its core functionality, user interface, and overall user experience. This process culminates in a comprehensive roadmap, outlining the app's features, design, and development strategy, ensuring alignment with your goals and setting a strong foundation for successful development. We also work to identify potential technical roadblocks early, and plan for them.",
  //     img: img1
  //   },
  //   {
  //     title: "Planning",
  //     content:
  //       "Planning is the cornerstone of successful mobile app development. We begin with a comprehensive analysis of your project requirements, defining clear objectives and scope. This involves creating a detailed project roadmap, outlining timelines, milestones, and resource allocation. We prioritize user-centric design, defining user stories and creating wireframes to visualize the app's structure and functionality. We select the appropriate technology stack, considering scalability and performance. We also plan for thorough testing, deployment strategies, and post-launch maintenance, ensuring a smooth and efficient development process that aligns with your business goals and minimizes potential risks. This also involves risk assessment, and contingency planning.",
  //     img: img2
  //   },
  //   {
  //     title: "Design",
  //     content:
  //       "Design in mobile app development is a crucial stage, blending aesthetics with functionality to create an engaging user experience. We begin by establishing a consistent visual language, reflecting your brand identity. prototypes are developed, iteratively refined based on user feedback. We prioritize responsive design, ensuring optimal viewing across diverse devices. Animations are incorporated to enhance user engagement and provide clear feedback. We ensure the design aligns with platform-specific guidelines, delivering a delightful user journey. The design process is collaborative, involving continuous communication with the development team to ensure seamless implementation and technical feasibility.",
  //     img: img3
  //   },
  //   {
  //     title: "Development",
  //     content:
  //       "With designs in hand, the development phase commences. Setting up the development environment is crucial to ensure that developers have the necessary tools and resources. This phase typically involves coding both the front-end (what users interact with) and back-end (server-side functionalities). Integrating APIs and third-party services is often necessary to enhance the app's capabilities, such as payment processing, social media sharing, or data storage.",
  //     img: img4
  //   },
  //   {
  //     title: "Testing",
  //     content:
  //       "Testing in mobile app development is a critical phase ensuring quality and reliability. We implement a multi-layered testing strategy, encompassing unit, integration, and system testing. User acceptance testing validates the app's functionality against user requirements. We conduct performance testing to ensure optimal speed and responsiveness under various loads. Compatibility testing verifies seamless operation across diverse devices and operating systems. Security testing identifies vulnerabilities, safeguarding user data. Regression testing ensures new features don't disrupt existing functionality. We employ automated testing tools and manual testing techniques, providing comprehensive coverage and identifying edge cases. Continuous integration and continuous delivery pipelines enable rapid feedback and iterative improvements.",
  //     img: img5
  //   },
  //   {
  //     title: "Deployment",
  //     content:
  //       "Deployment in mobile app development is the crucial process of releasing your application to users. We begin by preparing the app for distribution, ensuring it meets platform specific guidelines and store requirements (Apple App Store, Google Play Store). We accurately configure deployment settings, including version control, release notes, and metadata. We implement staging environments for final testing before production release. We manage the release process, carefully monitoring for any issues and ensuring a smooth transition for users. We provide ongoing support for updates and maintenance, ensuring compatibility with evolving operating systems and device changes. We leverage analytics to track app performance and user feedback, enabling continuous improvement and optimization. A well-planned deployment strategy minimizes risks and maximizes user adoption.",
  //     img: img6
  //   },
  //   {
  //     title: "Post-Launch & Maintenance",
  //     content:
  //       "Post-launch and maintenance are vital for long-term app success. Continuous monitoring tracks performance, user behavior, and crashes. Regular updates address bugs, enhance features, and ensure device compatibility. Security patches safeguard user data. User feedback informs improvements and support. Performance optimization maintains speed and responsiveness. Scalability ensures growth handling. App store optimization keeps listings relevant. This ongoing commitment ensures user satisfaction, extends app lifespan, and adapts to evolving technologies, maximizing return on investment and fostering user loyalty.",
  //     img: img7
  //   },
  //   {
  //     title: "Marketing & Promotion",
  //     content:
  //       "Marketing and promotion are essential for app visibility and user acquisition. We begin with a comprehensive market analysis to identify target audiences and competitive landscapes. We develop a multi-channel marketing strategy, social media campaigns, content marketing and paid advertising. We leverage influencer marketing and public relations to generate buzz and build credibility. We create compelling app store listings, highlighting key features and benefits. We implement analytics tracking to measure campaign effectiveness and optimize strategies. We engage with users through in-app promotions and push notifications. We foster community engagement through social media and forums. We continuously adapt our approach based on performance data and market trends, ensuring sustainable app growth and user acquisition.",
  //     img: img8
  //   }
  // ];
  const navigate = useNavigate();
  const handleClicked = () => {
    navigate("/contact");
  };

  // const handleSubmit = async () => {
  //   if (!firstName || !lastName || !gmail) {
  //     toast.error("Please fill all the required fields!");
  //     return;
  //   }

  //   const payload = {
  //     firstName: firstName,
  //     lastName: lastName,
  //     email: gmail,
  //     phonenumber: phone,
  //     message: message,
  //     type: "contact"
  //   };

  //   console.log(payload);

  //   try {
  //     const response = await axios.post(
  //       "https://tnreaders.in/web/contact",
  //       payload
  //     );
  //     console.log(response);

  //     if (response.status === 200) {
  //       toast.success("Submitted Successfully");
  //       setFirstName("");
  //       setLastName("");
  //       setGmail("");
  //       setMessage("");
  //     }
  //   } catch (error) {
  //     toast.error("Error submitting form. Please try again!");
  //     console.error("API Error:", error);
  //   }
  // };

  const features1 = [
    {
      img: "/images/image 123.webp",
      bgImg: "/images/bg1.webp",
      title: "Project Discussion",
      description:
        "After signing up, we will connect with you to finalize your thoughts before diving into the first phase of development."
    },
    {
      img: "/images/image 124.webp",
      bgImg: "/images/bg2.webp",
      title: "Wireframing & Designing",
      description:
        "We'll give you screen designs of your app, helping you visualize and understand it better."
    },
    {
      img: "/images/image 125.webp",
      bgImg: "/images/bg3.webp",
      title: "Development Stage",
      description:
        "During the development stage, our skilled developers bring your idea to life, turning it into a tangible reality."
    },
    {
      img: "/images/image 126.webp",
      bgImg: "/images/bg4.webp",
      title: "Testing & Quality Assurance",
      description:
        "Our advanced testing technology ensures thorough quality checks, eliminating errors. Once approved, we proceed to the next stage."
    }
  ];

  const developmentTypes = [
    { title: "Hybrid app development", icon: "/images/image 117.webp" },
    { title: "Native app development", icon: "/images/image 118.webp" },
    { title: "Cross platform app development", icon: "/images/image 119.webp" },
    { title: "Android app development", icon: "/images/image 120.webp" },
    { title: "iOS app development", icon: "/images/image 121.webp" },
    { title: "Windows app development", icon: "/images/image 122.webp" }
  ];

  return (
    <>
      <section className="appsection">
        <div className="appsection1">
          <motion.h2
            className="appsection2"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            Reliable mobile app development company in Salem for custom apps
          </motion.h2>
          <motion.p
            className="fsp appsection3"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8, ease: "easeOut" }}
          >
            Transform your digital presence with our mobile app development
            expertise, offering innovative API driven solutions.
          </motion.p>
          <motion.button
            className="uiuxbutton"
            onClick={handleClicked}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Let's talk &#8594;
          </motion.button>
        </div>
      </section>

      <section className="m d-none d-md-flex flex-column justify-content-center align-items-center">
        <h2 className="fsh2 m0 mb2">Services</h2>
        <h3 className="fsh3 m0 mb2">
          Mobile application development services we offer
        </h3>
        <div className="container9">
          {developmentTypes.map((service, index) => (
            <div className="service2-card" key={index}>
              <div className="icon2">
                <img src={service.icon} alt="" />
              </div>
              <h3 className="icon2h3">{service.title}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* <section className="sectioon2">
        <div className="sec2main">
          <div className="sec2sub1 m d-flex flex-column justify-content-md-center justify-content-start align-items-start align-items-md-center">
            <h2 className="sec2sub1h44 fsh2 m0 mb2">Who we are</h2>
            <p className="sec2sub1pp fsp m0 mb2 col-10">
              We're a skilled mobile app team, passionate about building
              impactful digital solutions. Combining technical excellence with
              creative design, we deliver user-friendly applications for
              business growth.
            </p>
          </div>
          <div className="sec2sub2 justify-content-evenly align-items-center">
            <div className="sec2child1">
              <h4 className="different fsh3">Leading Mobile App Development</h4>
              <p className="differentpapp fsp">
                As a leading mobile app development company, we specialize in
                developing innovative, high-performance applications to your
                unique business needs. Our team of expert developers and
                designers combines technical strategy with creative vision,
                delivering seamless user experiences across iOS and Android
                platforms. We prioritize quality, efficiency and client
                satisfaction, ensuring your app not only meets but exceeds
                expectations, driving growth and engagement in the competitive
                digital landscape. <br />
                We build lasting client relationships based on trust and
                transparency. Our commitment to clear communication, reliable
                delivery, and exceptional results ensures your project's success
                and our mutual growth.
              </p>
              <button className="button">
                <a
                  style={{
                    textDecoration: "none",
                    color: "white",
                    fontWeight: "200",
                    fontSize: "18px"
                  }}
                  href="/contact"
                >
                  {" "}
                  Contact us <span className="arrow">&#8594;</span>
                </a>
              </button>
            </div>
            <div className="sec2child2">
              <div className="grandchild">
                <h1 className="grandchildp">GET IN TOUCH WITH US</h1>
                <div className="grandchildint">
                  <div>
                    <input
                      type="text"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      placeholder="Enter First Name"
                      className="sect2input2"
                      required
                    />
                  </div>
                </div>

                <div className="grandchildint1">
                  <div>
                    <input
                      type="text"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      placeholder="Enter Last Name"
                      className="sect2input2"
                      required
                    />
                  </div>
                </div>

                <div className="grandchildint2">
                  <div>
                    <input
                      className="sect2input2"
                      type="tel"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      placeholder="Enter Mobile Number"
                      required
                    />
                  </div>
                </div>

                <div className="grandchildint2">
                  <div>
                    <input
                      className="sect2input2"
                      type="email"
                      value={gmail}
                      onChange={(e) => setGmail(e.target.value)}
                      placeholder="Enter Gmail"
                      required
                    />
                  </div>
                </div>
                <div className="grandchildint3">
                  <div>
                    <textarea
                      className="sect2input2"
                      type="Message"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Message"
                      required
                    />
                  </div>
                </div>
                <button className="buttun" onClick={handleSubmit}>
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section className="mainsec2 d-flex flex-column justify-content-center align-items-center m">
        <div className="text-start text-md-center d-flex flex-column align-items-left align-items-md-center justify-content-center mb2">
          <h2 className="fsh2 m0 mb2">Process</h2>
          <p className="fsh3 m0 mb2">Mobile app development process</p>
        </div>

        <div className="row g-4">
          {features1.map((feature, index) => (
            <div key={index} className="col-md-10 col-lg-6">
              <div
                className="card shadow-sm p-3 h-100 d-flex flex-column justify-content-center align-items-center section2box"
                style={{ border: "2px solid #137eb1" }}
              >
                <div
                  className="d-flex justify-content-between justify-content-md-center align-items-center w-100"
                  onClick={() => isMobile && toggleAccordion(index)}
                  style={{ cursor: isMobile ? "pointer" : "default" }}
                >
                  <div className="d-flex flex-md-column align-items-center justify-content-center gap-3">
                    <div className="section2img">
                      <img
                        src={feature.img}
                        alt={feature.title}
                        className="card-img-top img-fluid"
                      />
                    </div>
                    <h5 className="fsh4">{feature.title}</h5>
                  </div>
                  <div>
                    {isMobile && (
                      <span className="fs-4">
                        {activeIndex === index ? "−" : "+"}
                      </span>
                    )}
                  </div>
                </div>

                <div
                  className={`card-body ${isMobile ? "accordion-content" : ""}`}
                  style={{
                    display: isMobile
                      ? activeIndex === index
                        ? "block"
                        : "none"
                      : "block",
                    transition: "all 0.3s ease"
                  }}
                >
                  {/* <h5 className="fsh4">{feature.title}</h5> */}
                  <p className="fsp">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="m d-flex justify-content-center align-items-center">
        <div className="builder">
          <div className="builderimage">
            <img
              src={"/images/guy.webp"}
              alt=""
              style={{
                height: "236px",
                marginBottom: "32px",
                textShadow: "2px 2px 4px #000000"
              }}
            />
          </div>
          <div className="buiderimage1">
            <h2 className="buiderimage1h2 fsh3" style={{ color: "white" }}>
              Better discussions, better decisions
            </h2>
            <p className="buiderimage1p fsp" style={{ color: "#FBBC04" }}>
              We are for everyone - Startups, SMBs, Enterprises. Connect with us
              for a conversation.
            </p>
            <button className="button" style={{ textAlign: "right" }}>
              <span className="text2">
                <a
                  style={{ color: "white", textDecoration: "none" }}
                  href="/contact"
                >
                  Speak to us &rarr;
                </a>
              </span>
              <div className="circle2"></div>
            </button>
          </div>
        </div>
      </section>

      {/* <section className="iwanttohide mt1 mb2">
        <div className="prodparent">
          <div className="productchild1">
            <h2 className="massh2 fsh2 m0 mb2">
              Our Mobile Application Show Case
            </h2>
          </div>
          <div className="productchild2">
            <div>
              <img src={talent} alt="" className="proimg" />
              <h1 className="fsh4 mt1">TALENT APP</h1>
            </div>
            <div className="verline"></div>
            <div>
              <img src={astrology} alt="" className="proimg" />
              <h1 className="fsh4 mt1">ASTROLOGY APP</h1>
            </div>
            <div className="verline"></div>
            <div>
              <img src={nutrition} alt="" className="proimg" />
              <h1 className="fsh4 mt1">NUTRITION APP</h1>
            </div>
            <div className="verline"></div>
            <div>
              <img src={hr} alt="" className="proimg" />
              <h1 className="fsh4 mt1">HR MANAGEMENT APP</h1>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="m">
        <div className="real">
          <div className="real1 d-flex align-items-md-center align-items-start justify-content-md-center justify-content-start text-md-center text-start">
            <h2 className="sec2sub1h44 fsh2 m0 mb2">
              Our <span>Commitment</span>
            </h2>
            <p className="reelh2pdig fsp m0 mb2 col-10">
              Our commitment in mobile app development is to develop
              high-quality, innovative solutions that exceed client
              expectations. We prioritize user-friendly design, technical
              precision, and transparent communication throughout the
              development process. We're dedicated to delivering reliable,
              scalable, and secure applications, fostering long-term
              partnerships built on trust and mutual success. We constantly
              adapt to evolving technologies, ensuring your app remains
              competitive and effective.
            </p>
          </div>
          <div className="real2 d-flex justify-content-md-around justify-content-start align-items-md-center align-items-start">
            <div className="real3 d-flex align-items-start align-items-md-center">
              <img src="/images/real1.webp" alt="" className="realimg" />
              <h2 className="fsh4">Complete Transparency</h2>
              <p className="realp fsp">
                We prioritize open communication with our clients at every step
                of the process. By keeping you informed about our actions and
                decisions, we ensure full accountability and foster a
                trustworthy partnership.
              </p>
            </div>
            <div className="real3 d-flex align-items-start align-items-md-center">
              <img src="/images/real2.webp" alt="" className="realimg" />
              <h2 className="fsh4">Timely Delivery</h2>
              <p className="realp fsp">
                Our agile development approach has led to an impressive track
                record of 95% on-time delivery, ensuring your projects are
                completed within budget and on schedule.
              </p>
            </div>
            <div className="real3 d-flex align-items-start align-items-md-center">
              <img src="/images/real3.webp" alt="" className="realimg" />
              <h2 className="fsh4">30-Day Support</h2>
              <p className="realp fsp">
                To enhance your experience, we provide 30 days of free support
                following project completion. This service is designed to
                address any questions or issues you may encounter.
              </p>
            </div>
            <div className="real3 d-flex align-items-start align-items-md-center">
              <img src="/images/real4.webp" alt="" className="realimg" />
              <h2 className="fsh4">24/7 Assistance</h2>
              <p className="realp fsp">
                Our support team is available 24/7, ready to connect you with
                the right experts for any assistance you need. Rest assured, we
                are here to support you whenever you require help.
              </p>
            </div>
          </div>
        </div>
      </section> */}
      <ContactPage />

      {/* <div className="app-development-container">
          <h1 className="fsh2">App Development Solutions</h1>

          <div className="development-types">
            <h2 className="fsh3">Development Approaches</h2>
            <div className="types-grid">
              {developmentTypes.map((type, index) => (
                <div
                  key={index}
                  className="d-flex descapp flex-column justify-content-md-center justify-content-start align-items-md-center align-items-start gap-2"
                >
                  <div className="aimage">
                    <img src={type.images} alt="" className="aimage1" />
                  </div>
                  <div className="h-25 descapp text-md-center text-start">
                    <h3 className="fsh3 descapp">{type.title}</h3>
                    <p className="fsp descapp">{type.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}
      {/*SECTION 3*/}
      {/* <section className="mainsec2 d-flex flex-column justify-content-center align-items-center m">
        <div className="text-center d-flex flex-column align-items-center -justify-content-center">
          <h2 className="m fsh2 m0 mb2 text-md-center text-start">
            Features of our mobile application development
          </h2>
        </div>

        <div className="row g-4 ">
          {features.map((feature, index) => (
            <div key={index} className="col-md-6 col-lg-4 ">
              <div className="card border-0 shadow-sm p-3 h-100 d-flex flex-column justify-content-center align-items-center section2img section2box">
                <img
                  src={feature.img}
                  alt={feature.title}
                  className="card-img-top img-fluid"
                />
                <div className="card-body">
                  <h5 className="fsh4">{feature.title}</h5>
                  <p className="fsp">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section> */}
      {/*SECTION 5*/}
      {/* <section>
        <div className="fivemain">
          <div
            className="roundimage"
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              gap: "120px"
            }}
          >
            <div>
              <img
                src="/images/rnd1.webp"
                alt=""
                style={{ width: "100px", height: "100px" }}
              />
            </div>
            <div>
              <h2 className="massh2 fsh2">Our App Development Process</h2>
            </div>
            <div>
              <img
                src="/images/rnd2.webp"
                alt=""
                style={{ width: "189px", height: "189px" }}
              />
            </div>
          </div>
          <div className="main">
            <div style={{ textAlign: "left" }}>
              <ol>
                {steps.map((step, index) => (
                  <li
                    key={index}
                    className={index === activeIndex ? "highlight" : "high"}
                  >
                    {step.title}
                  </li>
                ))}
              </ol>
            </div>

            <div className="content">
              <h1 className="conh1 fsh3">{steps[activeIndex].title}</h1>
              <p className="conp fsp">{steps[activeIndex].content}</p>
            </div>

            <div className="carousel">
              <div className="carousel-container">
                <div
                  className="carousel-slides"
                  style={{ transform: `translateX(-${activeIndex * 100}%)` }}
                >
                  {steps.map((step, index) => (
                    <img
                      key={index}
                      src={step.img}
                      alt={step.title}
                      className="simage"
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "30px"
            }}
          >
            <div>
              <button className="prev" onClick={handlePrev}>
                &#8592;
              </button>
            </div>
            <div className="carousel-dots">
              {steps.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${activeIndex === index ? "active" : ""}`}
                  onClick={() => setActiveIndex(index)}
                ></span>
              ))}
            </div>
            <div>
              <button className="next" onClick={handleNext}>
                &#8594;
              </button>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="appdevo m">
        <div className="design1 mb2">
          <div style={{ color: "white", textAlign: "left" }}>
            <h1 className="desh1 fsh4">
              Let’s Build
              <span style={{ color: "#FAAB1E" }}>Your App!</span> 
            </h1>
            <p style={{ color: "white" }} className="desh2 fsp">
              We’re excited to hear from you! If you have any inquiries about
              mobile app development don’t hesitate to reach out. Let’s discuss
              your business objectives and explore how we can turn your vision
              into reality!
            </p>
          </div>
          <div>
            <button className="hiremebtn1">
              <a
                style={{
                  textDecoration: "none",
                  color: "white",
                  fontWeight: "400",
                  fontSize: "20px"
                }}
                href="/contact"
              >
                Connect With Experts!
              </a>
            </button>
          </div>
        </div>
        <div className="parentcls mb1 text-md-center text-start d-flex justify-content-md-evenly justify-content-start align-items-md-center align-items-start">
          <div className="childcls">
            <img src={img9} alt="" className="cldimg" />
            <h2 className="cldh2 fsh3">Commitment</h2>
            <p className="cldp fsp">We don’t stop until we reach our goals.</p>
          </div>
          <div className="childcls">
            <img src={img10} alt="" className="cldimg" />
            <h2 className="cldh2 fsh3">Excellence</h2>
            <p className="cldp fsp">
              We don’t settle for less, as we have set our standards high.
            </p>
          </div>
          <div className="childcls">
            <img src={img11} alt="" className="cldimg" />
            <h2 className="cldh2 fsh3">Passion</h2>
            <p className="cldp fsp">
              We go beyond our comfort-zone to develop tools that promise
              enhanced customer empowerment.
            </p>
          </div>
          <div className="childcls">
            <img src={img12} alt="" className="cldimg" />
            <h2 className="cldh2 fsh3">Priority</h2>
            <p className="cldp fsp">
              Customers are our top priority. Customer satisfaction is our goal.
            </p>
          </div>
        </div>
      </section> */}
      {/* <section className="m">
        <div className="">
          <div className="text-center mb-5">
            <h2 className="fsh2 m0 mb2 section-heading">
              Mobile App Development Services
            </h2>
          </div>
          <div className="row g-4">
            {services.map((service, index) => (
              <div key={index} className="col-md-6 col-lg-4">
                <div className="service-card">
                  <div className="service-inner">
                    <div className="service-front">
                      <h3 className="fsh3">{service.title}</h3>
                    </div>
                    <div className="service-back">
                      <p className="fsp">{service.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
      {/* <section className="interestingfact m">
        <div className="interestingfacts">
          <div className="interestingfacts1">
            <h2 className="interestingfactsh fsh4">
              Interesting Facts And Figures Of Our Success
            </h2>
          </div>
          <div className="interestingfacts1">
            <img src="/images/image 41.webp" alt="" className="ifimages" />
            <h2 className="fsh3">250+</h2>
            <p>Projects</p>
          </div>
          <div className="interestingfacts1">
            <img src="/images/image 42.webp" alt="" className="ifimages" />
            <h2 className="fsh3">50+</h2>
            <p>Satisfied Clients</p>
          </div>
          <div className="interestingfacts1">
            <img src="/images/image 43.webp" alt="" className="ifimages" />
            <h2 className="fsh3">6+</h2>
            <p>Industry Experience</p>
          </div>
          <div className="interestingfacts1">
            <img src="/images/image 44.webp" alt="" className="ifimages" />
            <h2 className="fsh3">20+</h2>
            <p>Developement People</p>
          </div>
        </div>
      </section> */}

      {/* <section className="m">
        <div className="twelve">
          <div className="twelve1">
            <h2 className="twelveh2 fsh2 m0 mb2">
              Key Features of our Mobile App Development Company 
            </h2>
          </div>
          <div className="tweleve2">
            <div className="tweleve3">
              <div className="twelve5par">
                <img className="twelve5" src="/images/livetrack.webp" alt="" />
                <p className="twelve5p">Live Tracking</p>
              </div>
              <div className="twelve5par">
                <img className="twelve5" src="/images/nfc.webp" alt="" />
                <p className="twelve5p">NFC</p>
              </div>
              <div className="twelve5par">
                <img className="twelve5" src="/images/pgi.webp" alt="" />
                <p className="twelve5p">PGI</p>
              </div>
              <div className="twelve5par">
                <img className="twelve5" src="/images/obfus.webp" alt="" />
                <p className="twelve5p">Code Obfuscation</p>
              </div>
              <div className="twelve5par">
                <img className="twelve5" src="/images/finger.webp" alt="" />
                <p className="twelve5p">Fingerprint Access</p>
              </div>
              <div className="twelve5par">
                <img className="twelve5" src="/images/commerce.webp" alt="" />
                <p className="twelve5p">M-Commerce</p>
              </div>
            </div>
            <div className="twelve4">
              <img className="twelve6" src="/images/appdev1.webp" alt="" />
            </div>
            <div className="tweleve3">
              <div className="twelve5par">
                <img className="twelve5" src="/images/social.webp" alt="" />
                <p className="twelve5p">Social Media Integration</p>
              </div>
              <div className="twelve5par">
                <img className="twelve5" src="/images/apiint.webp" alt="" />
                <p className="twelve5p">3-API Integration</p>
              </div>
              <div className="twelve5par">
                <img className="twelve5" src="/images/barcode.webp" alt="" />
                <p className="twelve5p">Barcode Scanning</p>
              </div>
              <div className="twelve5par">
                <img className="twelve5" src="/images/wearable.webp" alt="" />
                <p className="twelve5p">Wearable Geo Location</p>
              </div>
              <div className="twelve5par">
                <img className="twelve5" src="/images/appchat.webp" alt="" />
                <p className="twelve5p">In-App Chat</p>
              </div>
              <div className="twelve5par">
                <img className="twelve5" src="/images/mapint.webp" alt="" />
                <p className="twelve5p">Map Integration</p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="hireme m">
        <div className="hiremain d-flex flex-column justify-content-start justify-content-md-center align-items-start align-items-md-center text-md-center text-start">
          <h1 className="fsh2 m0 mb2">
            Hire Our Professional App{" "}
            <span style={{ color: "black" }}> Developers</span>
          </h1>
          <p className="hiremainp fsp m0 mb2 col-10">
            If you have a Website problem, Hire our professional mobile app
            developers to bring your app ideas to live with innovative and
            high-performance solutions. We specialize in both iOS and Android
            development, offering expertise in native, hybrid, and
            cross-platform app development. Our skilled developers focus on
            delivering seamless user experiences, intuitive interfaces, and
            reliable functionality. Whether you're looking to build a custom
            app, integrate third-party services, or optimize performance, we
            provide end-to-end mobile app development services tailored to your
            business needs and goals, ensuring impactful results and user
            engagement.
          </p>
        </div>
        <div className="hire m1">
          <div className="hire1">
            <img src="/images/image 45.webp" alt="" className="hireimg" />
            <p className="fsh3">Monthly</p>
          </div>
          <div className="hire1">
            <img src="/images/image 46.webp" alt="" className="hireimg" />
            <p className="fsh3">Hourly</p>
          </div>
          <div className="hire1">
            <img src="/images/image 47.webp" alt="" className="hireimg" />
            <p className="fsh3">Maintenance</p>
          </div>
          <div className="hire1">
            <img src="/images/image 48.webp" alt="" className="hireimg" />
            <p className="fsh3">Contract</p>
          </div>
        </div>
        <div className="design p">
          <div style={{ color: "white" }}>
            <h3 className="fsh4 m0 mb2">
              Looking for{" "}
              <span style={{ color: "#FAAB1E" }}>
                Top-Tier Website Development?
              </span>
               
            </h3>
            <p style={{ color: "white" }} className="desh2 fsp m0 mb3">
              Hire Our Team of Expert Developers and Elevate Your Online
              Presence!
            </p>
          </div>
          <div>
            <button className="hiremebtn">
              <a
                style={{ textDecoration: "none", color: "white" }}
                href="/contact"
              >
                Hire Now!
              </a>
            </button>
          </div>
        </div>
      </section> */}
      {/* <section className="section1">
        <div>
          <div className="serviceclass1">
            <img src="/images/background.webp" alt="" />
          </div>
          <div className="serviceclass2">
            <h4 className="fsh2 mb2 serviceclass2h4">Leading Mobile App Development Company</h4>
            <p className="fsp webservicep col-10">
              Top-tier mobile app development with innovative and user-focused
              solutions. We build high-performance apps, driving your business
              growth with an expert team.
            </p>
            <button
              className="button"
              style={{ textAlign: "right" }}
              onClick={handleClicked}
            >
              <span className="text">Let's Talk &rarr;</span>
              <div className="circle"></div>
            </button>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default AppDev;
